exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info-page .wrapper-main .container .padding-container{padding-left:50px}.info-page .wrapper-main .container .padding-container h3{font-size:18px;color:#545454;font-weight:600;margin-top:20px;text-align:left}.info-page.privacy .wrapper-main .container p{max-width:100%}.info-page.privacy .wrapper-main .container h2{margin-top:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/home/privacy/privacy.scss
// module id = 596
// module chunks = 0